import { render, staticRenderFns } from "./NonUseFeeDetail.vue?vue&type=template&id=24ccd588&scoped=true"
import script from "./NonUseFeeDetail.vue?vue&type=script&lang=js"
export * from "./NonUseFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./NonUseFeeDetail.vue?vue&type=style&index=0&id=24ccd588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ccd588",
  null
  
)

export default component.exports